// extracted by mini-css-extract-plugin
export default {"deviceButton":"ToggleFaxesButton_deviceButton__lT2ux","icon":"ToggleFaxesButton_icon__T6zY5"};